export default __webpack_public_path__ + "static/media/okladka-14.ed2a83e3.jpg";